import { lazy, Suspense, ComponentType } from "react";
import Loading from "@lhd/components/Loading";

const withLazy = (
  importFunc: () => Promise<{ default: ComponentType<any> }>,
) => {
  const LazyComp = lazy(() =>
    importFunc()
      .then((module) => {
        try {
          sessionStorage.removeItem("chunk_load_failed_reload");
        } catch (e) {
          // ignore storage access errors
        }
        return module;
      })
      .catch((error) => {
        const isChunkLoadError =
          error &&
          (error.name === "ChunkLoadError" ||
            (error.message && error.message.includes("Loading chunk")));
        if (isChunkLoadError) {
          try {
            const chunkFailedKey = "chunk_load_failed_reload";
            const hasReloaded = sessionStorage.getItem(chunkFailedKey);
            if (!hasReloaded) {
              sessionStorage.setItem(chunkFailedKey, "true");
              window.location.reload();
              return new Promise<{ default: ComponentType<any> }>(() => {});
            }
          } catch (e) {
            // ignore storage access errors
          }
        }
        throw error;
      }),
  );
  const LazyCompWraper = (props: any) => (
    <Suspense fallback={<Loading />}>
      <LazyComp {...props} />
    </Suspense>
  );
  LazyCompWraper.displayName = "LazyCompWraper";
  return LazyCompWraper;
};

export default withLazy;
